import {updateFactory} from '@modifi/redux'
import {getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'
import {aUserFeedBackSubmitFailed, aUserFeedBackSubmitSuccessful} from '@modifi/plugin-onboarding'
import {mapFormDataToObject} from '../utils'
import {aUpdateRegistrationDetails} from '../../../../data/company-registration'
import {SECTION_REGISTRATION_NUMBERS} from '../../../../constants/sections'
import {aFetchInputFields} from '../../../../data/input-fields'

const apiClient = getAuthenticatedThemisClient()

const {reducer, actions, selectors} = updateFactory({
  actionNamePrefix: 'pages/registration-numbers/submit',
  rootSelector: state => state?.pages?.registrationNumbers?.submit,
  submitRequest:
    (a, externalCompanyId: string, changes: Record<string, any>) =>
    async (dispatch): Promise<void> => {
      const payload = mapFormDataToObject(changes)

      dispatch(a.pendingAction())

      try {
        const response = await apiClient.CompanyRegistrationDetails.update({
          body: payload,
        })?.then(res => res.data())
        await dispatch(aUpdateRegistrationDetails(response))
      } catch (e: any) {
        dispatch(a.errorAction(e))
        dispatch(aUserFeedBackSubmitFailed(SECTION_REGISTRATION_NUMBERS))
        return
      }

      await dispatch(aFetchInputFields())
      dispatch(a.successAction())
      dispatch(aUserFeedBackSubmitSuccessful(SECTION_REGISTRATION_NUMBERS))
    },
})

export default reducer

export const {
  selectUpdatePending: selectSubmitPending,

  selectUpdateErrorMessage: selectSubmitErrorMessage,
} = selectors

export const {aSubmit: aSubmitPage, aReset: aResetPage} = actions
